import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";

import styles from "./ContactForm.module.scss";
import i18n from "i18n";

export class ContactForm extends React.Component {
  render() {
    const { client, handleChange, error } = this.props;

    return (
      <>
        <div
          className={styles["client-contact-field"]}
          data-automation-id="input-address"
        >
          <MainInput
            label={i18n.t("address")}
            required={false}
            id={"client-address"}
            name="address"
            value={client ? client.address : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.address && error.address}
          />
        </div>
        <div
          className={styles["client-contact-field"]}
          data-automation-id="input-phone"
        >
          <MainInput
            label={i18n.t("phone")}
            required={true}
            id={"client-phone"}
            name="phone"
            value={client ? client.phone : ""}
            handleChange={handleChange}
            maxLength={100}
            error={error.phone && error.phone}
          />
        </div>
        <div
          className={styles["client-contact-field"]}
          data-automation-id="input-email"
        >
          <MainInput
            label={"Email"}
            required={false}
            id={"client-email"}
            name="email"
            value={client ? client.email : ""}
            handleChange={handleChange}
            maxLength={30}
            error={error.email && error.email}
          />
        </div>
      </>
    );
  }
}

export default ContactForm;
